module.exports = __webpack_public_path__ + "static/media/errorShield.a70fbe06.svg";